import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3413b124"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hot-body" }
const _hoisted_2 = { class: "column-tabs-header" }
const _hoisted_3 = {
  key: 0,
  class: "tabs-loading"
}
const _hoisted_4 = { class: "left-list-wrap" }
const _hoisted_5 = {
  key: 0,
  class: "panel-loading"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "video-row"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "item-main" }
const _hoisted_10 = {
  key: 0,
  class: "read-count"
}
const _hoisted_11 = {
  key: 1,
  class: "text-row"
}
const _hoisted_12 = {
  key: 0,
  class: "read-count"
}
const _hoisted_13 = {
  key: 2,
  class: "loading-more"
}
const _hoisted_14 = {
  key: 0,
  class: "panel-loading"
}
const _hoisted_15 = {
  key: 1,
  class: "article-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarTabBar = _resolveComponent("StarTabBar")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_StarColumnTabs = _resolveComponent("StarColumnTabs")!
  const _component_StarNoData = _resolveComponent("StarNoData")!
  const _component_StarArticleContent = _resolveComponent("StarArticleContent")!
  const _component_StarArticleStatement = _resolveComponent("StarArticleStatement")!
  const _component_StarXpGate = _resolveComponent("StarXpGate")!

  return (_openBlock(), _createBlock(_component_StarXpGate, { na: "starHotSubject" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["hot-page", { 'is-light': _ctx.isLight }]),
        style: _normalizeStyle({ background: _ctx.colors.bg })
      }, [
        _createVNode(_component_StarTabBar, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "left-wrap",
            style: _normalizeStyle(_ctx.leftWrapStyle)
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.tabsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_a_spin, { size: "small" })
                  ]))
                : (_openBlock(), _createBlock(_component_StarColumnTabs, {
                    key: 1,
                    modelValue: _ctx.activeColumnCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeColumnCode) = $event)),
                    list: _ctx.columnTabs,
                    onChange: _ctx.switchColumn
                  }, null, 8, ["modelValue", "list", "onChange"]))
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.listLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_a_spin)
                  ]))
                : (_openBlock(), _createElementBlock("ul", {
                    key: 1,
                    class: "article-list",
                    ref: "listRef",
                    onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onListScroll && _ctx.onListScroll(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleList, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.newsId,
                        class: _normalizeClass(["article-item", { 'active-item': _ctx.currentIndex === index }]),
                        onClick: ($event: any) => (_ctx.selectArticle(item, index))
                      }, [
                        (item.dataType === 4 && _ctx.getCover(item))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("img", {
                                src: _ctx.getCover(item),
                                class: "cover-image",
                                alt: ""
                              }, null, 8, _hoisted_8),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", {
                                  class: "item-title",
                                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                                }, _toDisplayString(item.title), 5),
                                _createElementVNode("div", {
                                  class: "item-time",
                                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatStarTime(item.showTime)) + " ", 1),
                                  (item.hitCount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formatHitCount(item.hitCount)), 1))
                                    : _createCommentVNode("", true)
                                ], 4)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", {
                                class: "item-title",
                                style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                              }, _toDisplayString(item.title), 5),
                              (item.introduction)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "item-subtitle",
                                    style: _normalizeStyle({ color: _ctx.colors.textMuted })
                                  }, _toDisplayString(item.introduction), 5))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: "item-time",
                                style: _normalizeStyle({ color: _ctx.colors.textMuted })
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.formatStarTime(item.showTime)) + " ", 1),
                                (item.hitCount)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.formatHitCount(item.hitCount)), 1))
                                  : _createCommentVNode("", true)
                              ], 4)
                            ]))
                      ], 10, _hoisted_6))
                    }), 128)),
                    (!_ctx.articleList.length && !_ctx.listLoading)
                      ? (_openBlock(), _createBlock(_component_StarNoData, {
                          key: 0,
                          isDark: _ctx.isDark
                        }, null, 8, ["isDark"]))
                      : _createCommentVNode("", true)
                  ], 544)),
              (_ctx.loadingMore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_a_spin, { size: "small" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 4),
          _createElementVNode("div", {
            class: "right-wrap",
            style: _normalizeStyle(_ctx.rightWrapStyle)
          }, [
            (_ctx.detailLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_a_spin)
                ]))
              : (_ctx.articleDetail.newsId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_StarArticleContent, {
                      article: _ctx.articleDetail,
                      "is-web-socket": true
                    }, null, 8, ["article"]),
                    _createVNode(_component_StarArticleStatement, { article: _ctx.articleDetail }, null, 8, ["article"])
                  ]))
                : (!_ctx.listLoading)
                  ? (_openBlock(), _createBlock(_component_StarNoData, {
                      key: 2,
                      isDark: _ctx.isDark
                    }, null, 8, ["isDark"]))
                  : _createCommentVNode("", true)
          ], 4)
        ])
      ], 6)
    ]),
    _: 1
  }))
}